module.exports = __webpack_public_path__ + "static/img/tky-kcbg6-nor@2x.4d6fbc01.png";